import BaseLayer from "./BaseLayer";
import {plotDisagreementsHelper} from "../utils/map_utils";

class StitchPostRound1Disagreementv2 extends BaseLayer {

    id = "stitchPostRound1Disagreementv2";
    label = "After";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {stitchPostR1Disagreement, textColor} = this.props;
        plotDisagreementsHelper(stitchPostR1Disagreement.result, this.props.slide, this.layer.getSource(), textColor);
        resolve();
    });
}

export default StitchPostRound1Disagreementv2;
